import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class GetParamRequest extends Request {
    constructor(paramId) {
        super({
            req: RequestTypes.GET_PARAM,
            req_id: 0,
            param_id: paramId
        });
    }
}

export default GetParamRequest;